const baseroute = '/licence_management';
export const Routes = {
  baseroute,
  addlicence: baseroute + '/add_licence',
};
